export default function Project(props) {
    return <div>{props.children}</div>;
}